/*
 * @Author: your name
 * @Date: 2020-07-02 10:56:20
 * @LastEditTime: 2020-07-29 16:39:44
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: /x-product-workspace/packages/x-project-app/src/pages/app-engine/app-engine-page/edit-modal-button-type.js
 */
const EditModalButtonTypeMap = {
  SUBMIT: {
    text: '提交',
    event: 'EDIT_MODAL_SUBMIT',
    executeFunction: 'submitFormData',
    showLoading: true
  },
  TEMP_SAVE: {
    text: '暂存',
    event: 'EDIT_MODAL_SUBMIT',
    executeFunction: 'tempSaveFormData',
    showLoading: true,
    noBack: true
  },
  SAVE: {
    text: '保存',
    event: 'EDIT_MODAL_SUBMIT',
    executeFunction: 'saveFormData',
    showLoading: true
  },
  RESTART: {
    text: '重新提交',
    executeFunction: 'doRestart',
    event: 'DO_RESTART'
  },
  APPROVE: {
    text: '同意',
    executeFunction: 'doApprove',
    event: 'DO_APPROVE'
  },
  REJECT: {
    text: '拒绝',
    executeFunction: 'doReject',
    event: 'DO_REJECT'
  },
  WITHDRAW: {
    text: '撤回',
    executeFunction: 'doWithDraw',
    event: 'DO_WITHDRAW'
  },
  INQUIRE: {
    text: '征询',
    executeFunction: 'doInquire',
    event: 'DO_INQUIRE'
  },
  REASSIGN: {
    text: '转交',
    executeFunction: 'doReassign',
    event: 'DO_REASSIGN'
  },
  ADDONE: {
    text: '加签',
    executeFunction: 'doAddOne',
    event: 'DO_ADDONE'
  },
  REPLY: {
    text: '回复',
    executeFunction: 'doReply',
    event: 'DO_REPLY'
  }
}

export default EditModalButtonTypeMap
